module.exports = __webpack_public_path__ + "img/ttb.584eddc3.svg";